import { adminHttpClient } from '../../../commons/adminHttpClient'
import OrderedPageFilter from '../../../commons/orderedPageFilter'
import PagedList from '../../../commons/PagedList'

import { ExpenseStatus } from 'domain/expenses/expenseStatus'

export interface PagedExpenses extends PagedList<Expense> {}

export interface Expense {
  id: string
  expenseNumber: number
  serviceProvider: string
  expenseStatus: ExpenseStatus
  purchasedDate: Date
  amount: number
  createdAt: Date
  expenseType: string
  familyMember: string
  messageToEmployee: string
  reviewCreatedAt?: Date
  expenseTypeId: number
  planPeriodId: string
  isDuplicate: boolean
}

const getExpensesApi = (filter: OrderedPageFilter, planPeriodId: string): Promise<any> => {
  return adminHttpClient.get(`/EEDashboard/GetReimbursed/Expense/${planPeriodId}/EmployeeReimbursementRequests`, filter)
}

export default getExpensesApi
